import { gql, useQuery } from '@apollo/client';

export const PO_SALE_ORDER_SHIPMENT_QUERY = gql`
  query PoSaleOrderShipment($id: Int!) {
    poSaleOrder {
      poSaleOrderShipment(id: $id) {
        id
        poSaleOrderId
        shipperId
        status
        nguoiNhanHang
        ngayGiaoHang
        lyDoKhongPhatDuoc
        ngayDVVCLayHang
        tienCOD
        trongLuongTinhCuocKg
        soKien
        phiShip
        phiHoanTra
        noiDungKhac
        dain
        createdAt
        modifiedAt
        poSaleOrder {
          id
          cd
        }
        shipper {
          id
          cd
          name
        }
        items {
          id
          productId
          unitId
          soLuongGuiGiao
          soLuongGiaoThanhCong
          isFree
          donGia
          thanhTienTruocCK
          chietKhau
          thanhTien
          product {
            id
            cd
            name
            barcode
            otherReference
            salesUnit {
              id
              cd
            }
          }
          unit {
            id
            cd
          }
        }
      }
    }
  }
`;

export interface PoSaleOrderShipmentQueryVariables {
  id: number;
}

export const usePoSaleOrderShipmentQuery = (options?: any) =>
  useQuery(PO_SALE_ORDER_SHIPMENT_QUERY, options);

